import type { ThemeContract } from './theme-contract';
import { defaultGlobalTokens } from './default-theme';
import {
  buttonTokens, checkboxTokens, inputTokens, searchInputTokens,
  tableTokens, badgeTokens, dropdownTokens, modalTokens,
  cardTokens, tabsTokens, tooltipTokens, spinnerTokens,
  statusMessageTokens, toggleTokens, toastTokens, paginationTokens,
  breadcrumbTokens, toolbarTokens, tagTokens, sidebarTokens,
  headerTokens, emptyStateTokens, fileUploadTokens, progressBarTokens,
  dragHandleTokens, splitViewTokens,
} from './tokens/components';

const defaultComponentTokens: Record<string, Record<string, string>> = {
  button: buttonTokens,
  checkbox: checkboxTokens,
  input: inputTokens,
  searchInput: searchInputTokens,
  table: tableTokens,
  badge: badgeTokens,
  dropdown: dropdownTokens,
  modal: modalTokens,
  card: cardTokens,
  tabs: tabsTokens,
  tooltip: tooltipTokens,
  spinner: spinnerTokens,
  statusMessage: statusMessageTokens,
  toggle: toggleTokens,
  toast: toastTokens,
  pagination: paginationTokens,
  breadcrumb: breadcrumbTokens,
  toolbar: toolbarTokens,
  tag: tagTokens,
  sidebar: sidebarTokens,
  header: headerTokens,
  emptyState: emptyStateTokens,
  fileUpload: fileUploadTokens,
  progressBar: progressBarTokens,
  dragHandle: dragHandleTokens,
  splitView: splitViewTokens,
};

export function applyTheme(
  theme?: Partial<ThemeContract>,
  root: HTMLElement = document.documentElement,
): void {
  // Apply global tokens with overrides
  const globalOverrides = {
    ...theme?.colors,
    ...theme?.typography,
    ...theme?.spacing,
    ...theme?.borders,
    ...theme?.shadows,
  };

  for (const [key, value] of Object.entries(defaultGlobalTokens)) {
    const override = globalOverrides[key as keyof typeof globalOverrides];
    root.style.setProperty(`--dp-${key}`, (override as string) ?? value);
  }

  // Apply component tokens with overrides
  for (const [componentName, tokens] of Object.entries(defaultComponentTokens)) {
    const overrides = theme?.components?.[componentName as keyof NonNullable<ThemeContract['components']>];
    for (const [key, value] of Object.entries(tokens)) {
      const override = overrides?.[key];
      root.style.setProperty(`--dp-${key}`, override ?? value);
    }
  }
}

export function removeTheme(root: HTMLElement = document.documentElement): void {
  const allTokens = { ...defaultGlobalTokens };
  for (const tokens of Object.values(defaultComponentTokens)) {
    Object.assign(allTokens, tokens);
  }
  for (const key of Object.keys(allTokens)) {
    root.style.removeProperty(`--dp-${key}`);
  }
}
